module.exports = __webpack_public_path__ + "static/media/lp_body1.0468e5f9.svg";